import { AUTH } from '../../store/types';
import user from '../../util/user';

export default {
    [AUTH.REQUEST] (state) {
        state.auth_status = 'checking';
        state.login_attempt += 1;
    },
    [AUTH.SUCCESS] (state, token) {
        state.auth_status = 'success';
        state.auth_token = token;
        sessionStorage.setItem('user-token', token);
    },
    [AUTH.ERROR] (state) {
        state.auth_status = 'error';
    },
    [AUTH.LOGOUT] (state) {
        state.auth_status = '';
    },
    [AUTH.INVALID_CREDENTIALS] (state) {
        state.failed_login += 1;
        state.auth_error = 'E-Mail oder Passwort sind falsch!';
    },
    [AUTH.TOKEN_EXPIRED] (state) {
        state.auth_status = 'error';
        state.auth_error = 'Your token has expired! Please login again';
    },
    [AUTH.TOKEN_INVALID] (state) {
        state.auth_status = 'error';
        state.auth_error = 'Invalid Token!';
    },
    [AUTH.CURRENT_USER] (state, userData) {
        user.setUserInStorage(userData);
        state.current_user = userData;
        state.access_rights = user.getUserRights();
    },
    [AUTH.CLEAR] (state) {
        state.access_rights = null;
        state.auth_token = null;
        state.current_user = null;
        state.is_authenticated = false;
        sessionStorage.removeItem('user-token');
        sessionStorage.removeItem('current-user');
    },
};



// WEBPACK FOOTER //
// ./src/modules/auth/mutations.js